import { Col, Container, Row, Button } from "reactstrap";
import "../styles/index.css";
import { FaArrowCircleLeft } from "react-icons/fa";
import AnnoncePublierForm from "../components/annoncePublierForm";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const AnnoncePublier = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <div
        style={{
          maxWidth: "100%",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <Container>
          <div className="page-title-box">
            <Row className="d-flex justify-content-center align-items-center">
              <Col md="4">
                <Button
                  color="primary"
                  style={{ backgroundColor: "#157088", borderRadius: "5px" }}
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <FaArrowCircleLeft />
                  {"   "}
                  {t("announcement.returnToHome")}
                </Button>
              </Col>
              <Col
                md="4"
                className="d-flex justify-content-center font-size-20 font-weight-bolder"
                style={{ color: "#157088" }}

              >
                {t("announcement.publishAnnouncement")}
              </Col>
              <Col md="4" className="d-flex justify-content-end">
                <Button
                  style={{
                    color: "#157080",
                    borderColor: "#157080",
                    backgroundColor: "white",
                    borderRadius: "8px",
                  }}
                  outline
                  onClick={() => {
                    navigate("/annonces");
                  }}
                >
                  {t("announcement.seeMyAnnouncements")}
                </Button>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <div className="page-content mt-0">
        <Container>
          <div
            className="page-title-box"
            style={{ backgroundColor: "#f3f8f9" }}
          >
            <Row
              className="d-flex justify-content-center"
              style={{ padding: "20px 30px" }}
            >
              <AnnoncePublierForm />
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

// const styles = {
//     titre: {
//         font: "Poppins",
//         color: "#000000",
//         fontSize: 15,
//         fontWeight: 500,
//     },
//     info: {
//         color: "#000000",
//         fontWeight: 300,
//     },
//     sectionTitle: {
//         fontSize: "16px",
//         fontWeight: "bold",
//         color: "#0B2839",
//         marginTop: "10px",
//         marginBottom: "20px",
//     },
//     sectionText: {
//         fontSize: "14px",
//         color: "#000",
//     },
//     sectionList: {
//         listStyle: "none",
//         padding: "0",
//     },
//     sectionListItem: {
//         fontSize: "14px",
//         color: "#000",
//         marginBottom: "20px",
//         display: "flex",
//         alignItems: "center",
//     },
//     advantageItem: {
//         display: "flex",
//         alignItems: "center",
//         marginBottom: "10px",
//     },
//     checkIcon: {
//         color: "#157088",
//         marginRight: "5px",
//     },
//     pointBoldBlue: {
//         width: "8px",
//         height: "8px",
//         backgroundColor: "#157088",
//         borderRadius: "50%",
//         marginRight: "10px",
//     },
// }

export default AnnoncePublier;
